var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFurtherResearchRequired({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "further_research_required",
    viewBox: "0 0 68.198058 68.198997",
    height: "68.198997pt",
    width: "68.198059pt",
    id: "svg6615",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3354"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "Clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 43.082 V 43.082 H 0 Z",
    id: "path3351"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(-393.17799,-38.686399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6756"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.099,68.199 C 52.932,68.199 68.198,52.932 68.198,34.1 68.198,15.267 52.932,0 34.099,0 15.266,0 0,15.267 0,34.1 0,52.932 15.266,68.199 34.099,68.199",
    style: {
      fill: "#f8eee1",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(393.178,38.6864)",
    id: "path6534"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "none"
    },
    id: "Group398",
    transform: "translate(396.677,42.1426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.30406,2.96119 1.61245,1.37135 c 0.03014,0.03014 0.10549,0.04521 0.13563,0 L 4.38367,3.94072 C 4.42888,3.89552 4.41381,3.85031 4.3686,3.8051 L 2.75615,2.43376 3.99186,0.987065 5.92078,2.62966 c 0.04521,0.03014 0.07535,0.04521 0.12056,0 L 6.37287,2.22278 c 0.03014,-0.03014 0.04521,-0.09042 0,-0.12056 L 3.93158,0.0226045 c -0.03014,-0.03013935 -0.09041,-0.03013935 -0.12055,0 L 0.0285328,4.46816 c -0.0452091,0.04521 -0.03013937,0.10549 0,0.13563 L 0.465554,4.98053 C 0.510763,5.01067 0.555972,5.01067 0.601181,4.96546 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(8.79968,48.631)",
    id: "path6536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.375233,3.20378 C -0.378249,4.63539 0.0587706,5.78068 1.18899,6.38347 2.31922,6.97119 3.49465,6.68486 4.24813,5.25325 l 1.67273,-3.1797 c 0.01507,-0.04521 0,-0.07535 -0.04521,-0.10548 L 5.34821,1.69681 C 5.303,1.68174 5.2578,1.68174 5.24273,1.72695 L 3.57,4.90665 C 3.0727,5.90124 2.28908,6.12729 1.52053,5.73548 0.751974,5.32859 0.51086,4.56004 1.02323,3.56545 L 2.68089,0.400823 C 2.71103,0.340545 2.69596,0.310406 2.65075,0.295336 L 2.12331,0.00901279 C 2.09317,-0.00605685 2.04796,-0.00605685 2.03289,0.0391521 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(14.4635,51.7335)",
    id: "path6538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.00299329,5.74156 C -0.0120764,5.80183 0.0331327,5.84704 0.0632721,5.86211 L 0.635921,5.99774 C 0.68113,6.01281 0.711269,5.98267 0.726339,5.92239 l 0.587721,-2.3358 0.81376,0.1959 0.8439,2.74269 c 0,0.03014 0.03014,0.04521 0.07535,0.06028 l 0.67814,0.16577 c 0.07535,0.01507 0.09042,0 0.07535,-0.09042 L 2.86624,3.91812 C 3.84577,4.00854 4.5239,3.52631 4.74995,2.60706 5.0212,1.55218 4.47869,0.738415 3.30326,0.452091 2.91145,0.346603 2.50456,0.256185 2.08261,0.150697 1.88671,0.105488 1.6908,0.0602788 1.49489,0 1.46475,0 1.41955,0.0150697 1.40448,0.0602788 Z M 1.47982,2.89338 1.97712,0.828834 3.15256,1.11516 C 3.86084,1.29599 4.19237,1.76315 4.0266,2.42622 3.86084,3.14957 3.31833,3.34547 2.65526,3.17971 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(20.8908,54.4062)",
    id: "path6540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0.617856 C 0,0.678135 0.0301393,0.708274 0.0753483,0.708274 L 1.85357,0.753483 1.73301,5.99773 c 0,0.0452 0.03014,0.07534 0.07535,0.07534 l 0.60279,0.01507 c 0.03014,0 0.07534,-0.03014 0.07534,-0.07534 L 2.60705,0.768553 4.3702,0.813762 c 0.06028,0 0.09042,-0.03014 0.09042,-0.090418 L 4.47569,0.195906 c 0,-0.045209 -0.03014,-0.090418 -0.07535,-0.090418 L 0.105488,0 C 0.045209,0 0.0150697,0.045209 0.0150697,0.090418 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(27.1021,55.4475)",
    id: "path6542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.16332,6.69092 1.73596,6.58543 c 0.04521,0 0.07535,-0.04521 0.06028,-0.10548 L 1.31401,3.88797 4.19232,3.36053 4.67454,5.95251 C 4.68961,6.01279 4.71975,6.04293 4.78003,6.02786 L 5.35268,5.92237 c 0.04521,0 0.09042,-0.04521 0.07535,-0.10549 L 4.37315,0.0602786 C 4.35808,0.0301393 4.31287,0 4.26766,0 L 3.69502,0.105487 C 3.63474,0.120557 3.6046,0.165766 3.61967,0.210975 L 4.07176,2.71254 1.19346,3.23997 0.741368,0.723343 C 0.726299,0.693203 0.696159,0.663064 0.650951,0.663064 L 0.0783042,0.768552 C 0.0330952,0.783621 -0.0121137,0.82883 0.00295595,0.874039 L 1.05783,6.61557 C 1.0729,6.67585 1.11811,6.70599 1.16332,6.69092 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(33.0537,54.6357)",
    id: "path6544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.9479,4.02923 3.90694,3.2004 C 3.96722,3.18533 3.99736,3.14013 3.96722,3.09492 L 3.77132,2.61269 C 3.74118,2.56748 3.71104,2.55241 3.65076,2.56748 L 1.69171,3.39631 0.938235,1.64824 3.28909,0.653644 C 3.3343,0.638574 3.36444,0.593365 3.3343,0.533087 L 3.12333,0.0508599 C 3.10826,0.0056511 3.06305,-0.00941849 3.01784,0.0056511 L 0.0641984,1.25643 C 0.0189896,1.28657 -0.0111495,1.33178 0.00392005,1.37698 L 2.2945,6.75683 C 2.30957,6.81711 2.36985,6.83218 2.41505,6.80204 L 5.44404,5.52112 C 5.48925,5.50605 5.50432,5.46084 5.48925,5.41563 L 5.27828,4.93341 C 5.26321,4.87313 5.218,4.87313 5.17279,4.8882 l -2.4262,1.02473 z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(39.3803,52.6947)",
    id: "path6546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3.47355,6.39475 c 0.04521,0.0452 0.09042,0.0452 0.13563,0.03013 L 4.07634,6.06321 c 0.0452,-0.01507 0.0452,-0.06028 0,-0.10548 L 2.65979,4.01374 3.32285,3.51645 5.96004,4.6316 c 0.03014,0 0.07535,0 0.10549,-0.03014 L 6.63817,4.19458 C 6.69845,4.14937 6.69845,4.10416 6.6231,4.07402 L 3.92564,3.03422 C 4.60377,2.34101 4.69419,1.51218 4.12154,0.743634 3.48862,-0.130405 2.49402,-0.250962 1.52957,0.47238 1.19804,0.713494 0.851434,0.954608 0.519902,1.21079 0.354136,1.33135 0.18837,1.45191 0.0226044,1.57246 c -0.03013922,0.01507 -0.03013922,0.07535 0,0.12056 z M 2.23784,3.4411 0.971991,1.73823 1.95152,1.01489 C 2.52416,0.592937 3.12695,0.653216 3.51876,1.19572 3.95578,1.78344 3.75987,2.31088 3.21737,2.71776 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(44.0025,50.1994)",
    id: "path6548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.46237,1.92198 C 2.20078,0.731475 3.45156,0.415013 4.65713,1.16849 5.87777,1.92198 6.14902,3.17276 5.39554,4.37833 L 4.88317,5.19209 0.949998,2.73574 Z M 5.98326,4.74 C 6.96278,3.17276 6.63125,1.50003 5.04894,0.5205 3.4817,-0.459026 1.85418,-0.0220066 0.87465,1.54524 L 0.0156802,2.91657 C -0.014459,2.96178 6.10597e-4,3.02206 0.0458195,3.03713 L 5.00373,6.14148 C 5.04894,6.17162 5.09415,6.15655 5.12429,6.11134 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(50.2121,43.1387)",
    id: "path6550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.93371,5.20198 5.11455,4.6444 C 5.12962,4.61426 5.12962,4.58412 5.08441,4.55398 L 3.63772,3.30319 4.48162,0.816686 6.38041,0.726268 C 6.42562,0.696128 6.45576,0.681059 6.47083,0.635849 l 0.1959,-0.5425099 c 0.01507,-0.0602789 0,-0.1054881 -0.07535,-0.09041836 L 0.307307,0.334455 c -0.04521,0 -0.090419,0.045209 -0.105489,0.105488 l -0.19590607,0.55758 c -0.01506973,0.060277 0,0.105487 0.03013947,0.120557 L 4.81316,5.23212 C 4.87344,5.27733 4.90357,5.26226 4.93371,5.20198 Z M 0.955305,0.997523 3.78841,0.861895 3.11028,2.83603 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(53.8991,37.9839)",
    id: "path6552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.61786,4.49079 c 0.060279,0 0.090419,-0.01507 0.090419,-0.06028 L 0.904185,2.66735 6.11832,3.22493 C 6.16353,3.24 6.19367,3.20986 6.20874,3.16465 L 6.26902,2.56186 c 0,-0.03014 -0.01507,-0.07535 -0.06028,-0.09042 L 0.994604,1.91386 1.17544,0.165767 C 1.19051,0.105488 1.16037,0.060279 1.10009,0.060279 L 0.572651,0 C 0.527442,0 0.482232,0.0150698 0.467162,0.060279 L 0,4.32502 C 0,4.3853 0.0452093,4.43051 0.0904185,4.43051 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(54.9436,30.8538)",
    id: "path6554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.24273,5.46674 6.19752,4.87903 c 0,-0.04521 -0.01507,-0.07535 -0.06027,-0.09042 L 4.31382,4.23104 4.08778,1.60893 5.79065,0.765029 C 5.82078,0.73489 5.85092,0.704751 5.85092,0.659542 L 5.80572,0.0868974 C 5.79065,0.0115494 5.76051,-0.0185898 5.70023,0.0115494 L 0.0641984,2.8597 C 0.0189896,2.87477 -0.0111495,2.91998 0.00392005,2.98026 L 0.0491288,3.56797 c 0,0.06028 0.0452088,0.10549 0.0904172,0.12056 L 6.16739,5.52702 c 0.06027,0.03014 0.09041,0 0.07534,-0.06028 z M 0.923165,3.19123 3.46993,1.94046 3.63569,4.02006 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(55.2703,24.2188)",
    id: "path6556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.67431,5.46061 7.47841,4.96331 C 7.46334,4.9181 7.41813,4.88796 7.35785,4.90303 L 3.21373,6.45519 5.91118,3.4865 C 5.92625,3.45636 5.94132,3.41115 5.92625,3.36594 L 5.73034,2.82344 C 5.71527,2.7933 5.67006,2.76316 5.60979,2.76316 L 1.63143,2.26587 5.79062,0.713703 C 5.8509,0.698634 5.88104,0.653425 5.8509,0.593147 L 5.65499,0.0657134 C 5.63992,0.00543528 5.59472,-0.00963426 5.53444,0.00543528 L 0.0641982,2.05489 C 0.0189896,2.06996 -0.0111495,2.11517 0.00392003,2.17545 L 0.229963,2.76316 C 0.245033,2.80837 0.275172,2.82344 0.32038,2.82344 L 5.12756,3.35087 1.85747,6.90728 C 1.81226,6.93742 1.79719,6.9977 1.82733,7.04291 l 0.18084,0.52743 c 0.03014,0.06028 0.12055,0.09042 0.1959,0.06028 L 7.61403,5.62637 C 7.67431,5.59623 7.70445,5.53595 7.67431,5.46061 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(0.978688,37.034)",
    id: "path6558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.26352,6.17012 C 5.11709,6.06464 6.27745,4.76865 6.17196,2.90001 6.05141,1.06151 4.75542,-0.0988514 2.90185,0.00663612 1.06335,0.112124 -0.112081,1.42318 0.00847576,3.26168 0.113963,5.13032 1.42502,6.27561 3.26352,6.17012 Z M 3.21831,5.43171 C 1.81683,5.50706 0.822237,4.61795 0.746889,3.21647 0.656471,1.84513 1.54558,0.835467 2.94706,0.775188 4.3636,0.68477 5.34313,1.57388 5.43355,2.94522 5.5089,4.36177 4.63486,5.34129 3.21831,5.43171 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(0,29.5464)",
    id: "path6560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.88009,5.92234 6.01571,5.33463 c 0,-0.03014 -0.01507,-0.07535 -0.07534,-0.09042 L 1.31401,4.17427 6.69384,2.20016 c 0.01507,0 0.04521,-0.04521 0.06028,-0.09042 l 0.1507,-0.67813 c 0.01507,-0.04521 0,-0.07535 -0.06028,-0.09042 L 1.14824,0 C 1.10303,0 1.04276,0.0150696 1.02769,0.0753478 L 0.90713,0.632922 C 0.89206,0.6932 0.937269,0.738409 0.982478,0.738409 L 5.60884,1.80835 0.244069,3.78246 C 0.21393,3.8126 0.168721,3.8126 0.153652,3.87288 L 0.00295593,4.55101 C -0.0121136,4.59622 0.0330951,4.6565 0.0783038,4.6565 L 5.7746,5.98262 C 5.83488,5.99769 5.86502,5.95248 5.88009,5.92234 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(0.277967,21.8867)",
    id: "path6562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.365589,0.0156801 C 0.32038,-0.014459 0.260102,6.10593e-4 0.245033,0.0458192 L 0.00392003,0.588323 C -0.0111495,0.618462 0.0189896,0.67874 0.0641982,0.708879 L 5.42896,3.04466 C 5.47416,3.05973 5.51937,3.02959 5.53444,2.99945 l 0.24112,-0.5425 c 0.01507,-0.04521 0,-0.09042 -0.04521,-0.10549 z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2.51354,18.3359)",
    id: "path6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.494711,4.0898 C 0.53992,4.11994 0.585129,4.10487 0.600198,4.07473 L 1.53451,2.5527 6.01018,5.29537 C 6.04032,5.3255 6.08553,5.31043 6.11567,5.2803 L 6.43213,4.76793 c 0.01507,-0.03014 0,-0.07535 -0.03014,-0.10549 L 1.92632,1.91977 2.84557,0.412815 C 2.87571,0.352536 2.86064,0.322397 2.81543,0.292258 L 2.36334,0.0210052 C 2.3332,-0.00913403 2.27292,-0.00913403 2.25785,0.0360748 L 0.0124841,3.69799 c -0.0301392,0.04521 0,0.09042 0.0301392,0.12055 z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3.77009,12.463)",
    id: "path6566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.85836,5.21062 C 2.079,6.59702 3.812,6.73265 5.21348,5.48187 6.59988,4.26123 6.70537,2.51316 5.48473,1.12675 4.24902,-0.259653 2.51602,-0.38021 1.12961,0.840429 -0.271861,2.09121 -0.377348,3.82421 0.85836,5.21062 Z M 1.41594,4.72839 C 0.46655,3.67352 0.556968,2.33232 1.61184,1.398 2.65164,0.493827 3.99284,0.569176 4.91209,1.63912 5.8464,2.70906 5.77105,4.02012 4.73125,4.92429 3.66131,5.87368 2.35025,5.79833 1.41594,4.72839 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(8.81452,7.33753)",
    id: "path6568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.80886,6.45075 C 2.839,6.49596 2.89928,6.51103 2.94448,6.49596 L 3.45685,6.20964 C 3.48699,6.1795 3.50206,6.13429 3.47192,6.08908 L 2.31156,3.96427 3.0349,3.57246 5.52139,5.01914 c 0.03014,0.03014 0.06028,0.03014 0.10548,0 L 6.24473,4.68761 c 0.06028,-0.04521 0.06028,-0.07535 0,-0.12056 L 3.69796,3.18065 C 4.46651,2.57787 4.66242,1.76411 4.21033,0.935279 3.69796,-0.0291756 2.73351,-0.270289 1.66357,0.317425 1.31697,0.51333 0.940227,0.709235 0.578557,0.90514 0.382652,1.01063 0.216886,1.10104 0.0360511,1.20653 0.00591188,1.2216 -0.00915773,1.28188 0.00591188,1.31202 Z M 1.98003,3.34642 0.955297,1.47778 2.01017,0.90514 C 2.64309,0.558539 3.23081,0.694165 3.54727,1.29695 3.90894,1.94494 3.63769,2.45731 3.0349,2.77377 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(14.8047,3.4035)",
    id: "path6570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.712284,0.0783044 C 0.697214,0.0330954 0.667075,-0.0121137 0.621866,0.00295596 L 0.0492174,0.213932 c -0.0301394,0 -0.0602788,0.060279 -0.04520907,0.105488 L 1.948,5.83493 C 1.96307,5.88014 2.02335,5.89521 2.05349,5.89521 L 2.62614,5.68423 C 2.67134,5.66916 2.67134,5.63902 2.65628,5.59381 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(20.6157,1.62451)",
    id: "path6572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.889102,6.61552 1.49188,6.5251 c 0.03014,0 0.07535,-0.03014 0.06028,-0.09042 L 0.889102,1.73299 4.67155,6.04288 c 0.01507,0 0.06028,0.03014 0.10549,0.03014 l 0.6932,-0.10549 c 0.03013,0 0.06027,-0.03014 0.0452,-0.09042 L 4.71676,0.0753476 C 4.71676,0.030139 4.67155,0 4.62634,0 L 4.0537,0.0904171 c -0.06028,0 -0.07535,0.0452089 -0.07535,0.0904169 L 4.64141,4.88252 0.889102,0.587711 C 0.858963,0.557572 0.828824,0.542503 0.768545,0.542503 L 0.0602781,0.647989 C 0.030139,0.647989 0,0.693198 0,0.738406 L 0.813754,6.5251 c 0.01507,0.06028 0.060278,0.09042 0.075348,0.09042 z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(24.3374)",
    id: "path6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.92728,3.9039 C 4.59575,5.03413 3.81213,5.57663 2.63669,5.3958 1.31056,5.19989 0.572152,4.14502 0.768057,2.75861 0.979032,1.3722 2.06405,0.573508 3.45046,0.784483 4.12859,0.874901 4.6711,1.2215 4.98756,1.59824 c 0,0.01507 0.01507,0.03014 0.04521,0.03014 0.01507,0 0.03014,0 0.07535,-0.01507 L 5.54514,1.26671 C 5.57528,1.25164 5.57528,1.20643 5.56021,1.16122 5.09305,0.588577 4.44505,0.166627 3.55594,0.0460697 1.70238,-0.240254 0.315967,0.829692 0.0447136,2.65312 -0.22654,4.49162 0.752987,5.87803 2.53121,6.13421 4.30943,6.42053 5.43965,5.38073 5.77118,3.45181 5.77118,3.4066 5.74104,3.34632 5.69583,3.34632 L 3.19427,2.96958 c -0.04521,0 -0.09042,0.01507 -0.09042,0.07535 L 3.02851,3.52716 c 0,0.04521 0.01507,0.10549 0.0452,0.10549 z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(31.7815,0.293272)",
    id: "path6576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1.89938,3.23738 1.8837,0.99459 C 3.81322,4.24704 3.87349,4.24704 3.90363,4.18676 L 4.14475,3.73467 C 4.17489,3.68946 4.15982,3.64425 4.11461,3.61411 L 2.23091,2.61952 3.10495,0.946798 5.35031,2.1373 c 0.04521,0.01507 0.09042,0 0.12056,-0.06028 L 5.71198,1.60986 C 5.74212,1.57972 5.72705,1.51944 5.68184,1.50437 L 2.84876,0.0124841 c -0.04521,-0.0301392 -0.09042,0 -0.12055,0.0301391 L 0.0156802,5.22656 C -0.014459,5.27177 6.10595e-4,5.31698 0.0458193,5.34712 L 0.558185,5.6033 C 0.588324,5.63344 0.648603,5.61837 0.678742,5.57316 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(41.2798,3.06973)",
    id: "path6578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.86512,1.11377 C -0.370586,2.50017 -0.280168,4.23317 1.1213,5.48394 2.49263,6.71965 4.22564,6.62923 5.46134,5.24283 6.71212,3.85643 6.60663,2.10836 5.2353,0.872653 3.83383,-0.378123 2.1159,-0.272636 0.86512,1.11377 Z m 0.5425,0.49729 C 2.35701,0.556191 3.6982,0.495913 4.75307,1.43023 5.7778,2.34947 5.85315,3.69066 4.8887,4.73047 3.95438,5.78534 2.62826,5.84561 1.60353,4.92637 0.548659,3.97699 0.473311,2.66593 1.40762,1.61106 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(46.3562,7.08819)",
    id: "path6580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.0458193,3.21573 C 6.10594e-4,3.24587 -0.014459,3.30615 0.0156802,3.33628 L 0.332141,3.83358 C 0.36228,3.87879 0.407489,3.87879 0.452697,3.84865 L 2.47202,2.52253 2.92411,3.21573 1.6884,5.79262 c -0.03014,0.03014 -0.03014,0.07535 0,0.10549 L 2.08021,6.50089 C 2.11035,6.56117 2.15556,6.56117 2.1857,6.47075 L 3.37619,3.84865 C 4.03925,4.57199 4.85301,4.69255 5.6517,4.16511 6.55587,3.5774 6.7367,2.59788 6.07364,1.58822 5.86267,1.25669 5.62156,0.895016 5.39551,0.548416 5.27496,0.367581 5.16947,0.201816 5.04891,0.036051 5.03384,0.00591186 4.97357,-0.0091577 4.94343,0.00591186 Z M 3.05973,2.13072 4.83794,0.970364 5.501,1.98002 C 5.89281,2.58281 5.81746,3.18559 5.24482,3.54726 4.62697,3.95414 4.08446,3.71302 3.72279,3.14038 Z",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(50.7166,12.5664)",
    id: "path6582"
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    style: {
      fill: "none",
      stroke: "none"
    },
    id: "Group399",
    transform: "translate(405.736,51.2453)",
    clipPath: "url(#Clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21.541,43.082 c 11.897,0 21.541,-9.644 21.541,-21.541 C 43.082,9.644 33.438,0 21.541,0 9.644,0 0,9.644 0,21.541 0,33.438 9.644,43.082 21.541,43.082",
    style: {
      fill: "#f3a18b",
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path6585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.522,7.231 -1.727,1.367 -0.555,0.441 -2.013,1.592 0.441,0.557 1.572,-1.245 v 1.077 c -0.478,0.676 -1.775,2.311 -4.063,3.032 -0.359,0.114 -1.209,0.343 -2.251,0.343 -4.159,0 -7.529,-3.37 -7.529,-7.529 0,-2.315 1.045,-4.388 2.69,-5.767 C 3.669,0.864 3.354,0.47 3.221,0 1.252,1.638 0,4.105 0,6.866 c 0,4.928 3.995,8.925 8.926,8.925 1.227,0 2.194,-0.256 2.628,-0.393 3.148,-0.996 4.766,-3.531 5.258,-4.378 V 8.698 l 1.151,-0.911 z",
    style: {
      fill: "#2c5ba7",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(13.2712,14.6464)",
    id: "path6587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.346,7.576 C 11.341,7.532 11.338,7.49 11.334,7.446 11.216,6.868 10.699,6.427 10.086,6.427 H 7.382 C 7.393,6.352 7.397,6.275 7.397,6.198 V 1.718 C 7.397,1.245 7.205,0.815 6.893,0.505 6.581,0.193 6.151,0 5.679,0 4.734,0 3.961,0.773 3.961,1.718 v 4.48 c 0,0.077 0.005,0.154 0.016,0.229 H 1.273 C 0.66,6.427 0.143,6.868 0.025,7.446 0.021,7.49 0.017,7.532 0.013,7.576 0.008,7.617 0.003,7.659 0,7.7 V 8.21 H 11.359 V 7.7 C 11.356,7.659 11.351,7.617 11.346,7.576",
    style: {
      fill: "#f8eee1",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(16.135,28.0567)",
    id: "path6589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.307,10.693 8.464,12.943 0,2.25 2.843,0 Z",
    style: {
      fill: "#f8eee1",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(15.7607,8.2797)",
    id: "path6591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.36,0.847 0.671,2.184 0,1.337 1.689,0 Z",
    style: {
      fill: "#2c5ba7",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(24.8027,19.4292)",
    id: "path6593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.208,1.656 1.309,3.157 1.16,2.968 0.592,2.25 0,1.502 1.898,0 Z",
    style: {
      fill: "#f8eee1",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(14.9224,6.9985)",
    id: "path6595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.65983,0.579564 0.525831,2.26856 c -0.141,0.111 -0.345,0.088 -0.456,-0.053 -0.111,-0.141 -0.087,-0.345 0.053,-0.456 L 2.25683,0.0705637 c 0.141,-0.112 0.345,-0.088 0.456,0.0530003 0.111,0.14 0.088,0.345 -0.053,0.456",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(14.2809,6.32724)",
    id: "path6597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.53314,0.579564 0.526142,2.95956 c -0.141,0.112 -0.345,0.088 -0.456,-0.053 -0.111,-0.14 -0.088,-0.345 0.053,-0.456 L 3.13014,0.0705637 c 0.14,-0.112 0.345,-0.088 0.456,0.0530003 0.111,0.14 0.088,0.345 -0.053,0.456",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(15.5551,8.14464)",
    id: "path6599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.53314,0.579564 0.526142,2.95956 c -0.141,0.112 -0.345,0.088 -0.456,-0.053 -0.111,-0.14 -0.088,-0.345 0.053,-0.456 L 3.13014,0.0705637 c 0.141,-0.112 0.345,-0.088 0.456,0.0530003 0.111,0.141 0.088,0.344 -0.053,0.456",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(23.6177,18.3276)",
    id: "path6601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.365,0.542 0.429,5.24 0,4.698 5.936,0 Z",
    style: {
      fill: "#f8eee1",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(25.3281,20.6236)",
    id: "path6603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.676,1.837 C 3.676,1.884 3.675,1.929 3.67,1.975 3.601,2.926 2.806,3.676 1.839,3.676 1.509,3.676 1.203,3.59 0.936,3.439 0.519,3.204 0.204,2.81 0.071,2.34 0.023,2.18 0,2.011 0,1.837 0,0.823 0.823,0 1.839,0 2.399,0 2.9,0.251 3.239,0.646 3.512,0.967 3.676,1.383 3.676,1.837",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(16.4218,12.3061)",
    id: "path6605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.185,1.093 C 2.185,1.697 1.696,2.186 1.092,2.186 0.489,2.186 0,1.697 0,1.093 0,0.489 0.489,0 1.092,0 1.696,0 2.185,0.489 2.185,1.093",
    style: {
      fill: "#f8eee1",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(17.1682,13.0507)",
    id: "path6607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.06,0.53 C 1.06,0.823 0.823,1.06 0.53,1.06 0.237,1.06 0,0.823 0,0.53 0,0.237 0.237,0 0.53,0 0.823,0 1.06,0.237 1.06,0.53",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(21.2846,29.1432)",
    id: "path6609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.359,0.124 v 0.51 H 0 V 0.124 C 0.003,0.083 0.008,0.041 0.013,0 h 11.333 c 0.005,0.041 0.01,0.083 0.013,0.124",
    style: {
      fill: "#24354e",
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(16.1347,35.6329)",
    id: "path6611"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurtherResearchRequired);
export default __webpack_public_path__ + "static/media/further_research_required.214c0703d28dacd3e04635877b4425ce.svg";
export { ForwardRef as ReactComponent };